<nz-row *ngIf="bulkPayload" [nzGutter]="16" class="items-start">
  	<nz-col [nzSpan]="19">

		<nz-page-header nzTitle="Send Communication"></nz-page-header>
		<div class="row">
			<div class="col-2">
				<nz-divider nzText="Channel" nzOrientation="left"></nz-divider>
				<form nz-form [formGroup]="communicationForm" class="w-full">
					<nz-form-control [nzSpan]="14">
						<nz-radio-group formControlName="sendType">
							<label nz-radio nzValue="email">Email</label>
							<label nz-radio nzValue="sms">SMS</label>
						</nz-radio-group>
					</nz-form-control>
				</form>
			</div>
			<div class="col-6">
				<nz-divider nzText="Recipients" nzOrientation="left"></nz-divider>
				<div class="flex items-center justify-content-between mb-3">
					<button nz-button nzType="default" (click)="openRecipientFilters()">Filter Recipients</button>

					<span class="ms-5 text-primary">{{filterCount}} member(s) selected</span>

					<div *ngIf="selectedFilters.length > 0" class="mt-1 flex flex-wrap gap-2">
						<nz-tag
						*ngFor="let f of selectedFilters; let i = index"
						nzColor="blue">
							<ng-container *ngTemplateOutlet="filterTemplate; context: { $implicit: f }"></ng-container>
							<button type="button" (click)="removeFilter(i)"
									class="absolute top-0 right-0 p-0 m-0 bg-transparent border-0 cursor-pointer"
									style="font-size: 12px; line-height: 1; width: 16px; height: 16px;">
								&nbsp;&nbsp;×
							</button>
						</nz-tag>
					</div>
				</div>
			</div>
			<div class="col-4">
				<nz-divider nzText="Delivery" nzOrientation="left"></nz-divider>
				<form nz-form [formGroup]="deliveryForm" class="w-full">
					<nz-form-control [nzSpan]="14" class="w-full">
						<div class="row">
							<div class="col">
								<div class="d-flex align-items-center gap-2">
									<label nz-checkbox formControlName="schedule" style="white-space: nowrap;" [nzDisabled]="bulkPayload.trigger !== undefined">Schedule Delivery</label>
									<button 
										*ngIf="bulkPayload.trigger" 
										nz-button 
										nzType="default" 
										nzShape="circle" 
										nzSize="small"
										nz-tooltip="Clear Schedule"
										class="small-schedule-btn"
										(click)="clearSchedule()">
										<span nz-icon nzType="delete" nzTheme="outline"></span>
									</button>
									<button 
										*ngIf="bulkPayload.trigger" 
										nz-button 
										nzType="default" 
										nzShape="circle" 
										nzSize="small"
										nz-tooltip="Edit Schedule" 
										class="small-schedule-btn"
										(click)="showSchedule()">
										<span nz-icon nzType="edit" nzTheme="outline"></span>
									</button>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<label nz-checkbox formControlName="deliveryReport" style="white-space: nowrap;">Request Delivery Report</label>
							</div>
						</div>
					</nz-form-control>
				</form>
			</div>
		</div>
		
		<div *ngIf="isSms()">
			<nz-divider nzText="SMS" nzOrientation="left"></nz-divider>
			<form nz-form [formGroup]="smsForm" class="w-full">
				<nz-form-item >
					<nz-form-label [nzSpan]="2" nzRequired>Body</nz-form-label>
					<nz-form-control [nzSpan]="22" [nzErrorTip]="'Body is required'">
						<app-email-body-editor formControlName="message" [placeholders]="placeholders"></app-email-body-editor>
						<div class="text-end mt-1 text-sm text-gray-500" [ngClass]="{'text-danger': (smsForm.get('message')?.value?.length >= 160)}">
							{{ smsForm.get('message')?.value?.length || 0 }}/160
						</div>
					</nz-form-control>
				</nz-form-item>
			</form>
		</div>
		<div *ngIf="isEmail()">
			<nz-divider nzText="Email" nzOrientation="left"></nz-divider>
			<form nz-form [formGroup]="emailForm" class="w-full">
				<nz-form-item>
					<nz-form-label [nzSpan]="2" nzRequired>Subject</nz-form-label>
					<nz-form-control [nzSpan]="12" [nzErrorTip]="'Subject is required'">
						<input nz-input formControlName="subject" />
					</nz-form-control>
				</nz-form-item>
				<nz-form-item >
					<nz-form-label [nzSpan]="2" nzRequired>Body</nz-form-label>
					<nz-form-control [nzSpan]="22" [nzErrorTip]="'Body is required'">
						<app-email-body-editor formControlName="message" [placeholders]="placeholders"></app-email-body-editor>
					</nz-form-control>
				</nz-form-item>
			</form>
		</div>
		<nz-divider nzText="Attachments" nzOrientation="left"></nz-divider>
		<nz-upload 
			[nzMultiple]="true" 
			[nzCustomRequest]="customUpload" 
			[nzShowUploadList]="true"
			[nzFileList]="uploadedFileList"
			(nzChange)="handleUploadChange($event)">
			<button nz-button>
				<i nz-icon nzType="upload"></i>
				Upload file
			</button>
		</nz-upload>
		<!-- <form nz-form [formGroup]="attachmentForm" class="w-full">
			<div *ngIf="bulkPayload.attachments" formArrayName="attachments" class="mt-2">
				<nz-list>
					<nz-list-item *ngFor="let attachment of bulkPayload.attachments; let i = index" [formGroupName]="i">
						<label nz-checkbox formControlName="selected">
							{{ attachment.fileName }}
						</label>
					</nz-list-item>
				</nz-list>
			</div>
		</form> -->
	</nz-col>
	<nz-col [nzSpan]="5">
		<div class="summary rounded-lg shadow-sm p-3">
			<h4 class="text-white-700 mb-3 summary-heading"><span class="me-2 fs-1" nz-icon nzType="info-circle" nzTheme="outline"></span></h4>
			<div class="mb-3">
				<p class="m-0 summary-title"><span class="me-2" nz-icon nzType="message" nzTheme="outline"></span>Channel</p>
				<p class="m-0">{{ communicationForm.value.sendType | uppercase }}</p>
			</div>

			<div class="mb-3">
				<p class="m-0 summary-title"><span class="me-2" nz-icon nzType="aim" nzTheme="outline"></span>Target Criteria</p>
				<div class="m-0" *ngIf="selectedFilters">
					<div *ngFor="let f of selectedFilters">
						<ng-container *ngTemplateOutlet="filterTemplate; context: { $implicit: f }"></ng-container>
					</div>
				</div>
				<div class="m-0" *ngIf="selectedFilters.length === 0" class="text-danger">No filters applied</div>
			</div>

			<div class="mb-3">
				<p class="m-0 summary-title"><span class="me-2" nz-icon nzType="team" nzTheme="outline"></span>Recipients</p>
				<p class="m-0" [ngClass]="{'text-danger': filterCount === 0}">
					{{ summaryFilterCount }}
				</p>
			</div>

			<div class="mb-3">
				<p class="m-0 summary-title"><span class="me-2" nz-icon nzType="calendar" nzTheme="outline"></span>Scheduled</p>
				<p class="m-0">{{ bulkPayload.trigger ? 'Yes' : 'No' }}</p>
			</div>

			<div class="mb-3" *ngIf="bulkPayload.trigger">
				<p class="m-0 summary-title"><span class="me-2" nz-icon nzType="clock-circle" nzTheme="outline"></span>When</p>
				<p class="m-0">{{ bulkPayload.trigger.description ? bulkPayload.trigger.description : bulkPayload.trigger.triggerDescription }}</p>
			</div>

			<div class="mb-3">
				<p class="m-0 summary-title"><span class="me-2" nz-icon nzType="check-circle" nzTheme="outline"></span>Delivery Report</p>
				<p class="m-0">{{ this.deliveryForm.get('deliveryReport')?.value ? 'Yes' : 'No' }}</p>
			</div>
		</div>
  	</nz-col>
</nz-row>
<nz-row><nz-col><button nz-button nzType="primary" class="mt-5" (click)="save()">Save</button></nz-col></nz-row>

<ng-template #filterTemplate let-filter>
	<app-filter-info [filter]="filter"></app-filter-info>
</ng-template>